import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { fetchLegalBasisLevels } from 'APIPackage/CatalogsModule/services/legalBasisApi';
import { ILegalBasisLevel } from 'APIPackage/CatalogsModule/interfaces/ILegalBasisLevel';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';

import { ILegalBasisLevelSelectOption } from '../interfaces/ILegalBasisLevelSelectOption';

export function useLegalBasisLevels(isOn?: boolean) {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isMounted = useMountedState();
  const [legalBasisLevels, setLegalBasisLevels] = useState<ILegalBasisLevel[]>([]);
  const [legalBasisLevelsSelectOptions, setLegalBasisLevelsSelectOptions] = useState<ILegalBasisLevelSelectOption[]>(
    [],
  );

  const refresh = useCallback(async () => {
    try {
      dispatch(coreSetLoading(true));
      const levels = await fetchLegalBasisLevels();

      isMounted() && setLegalBasisLevels(levels);
    } finally {
      dispatch(coreSetLoading(false));
    }
  }, [dispatch, isMounted]);

  useEffect(() => {
    isOn && refresh();
  }, [isOn, refresh]);

  useEffect(() => {
    const options: ILegalBasisLevelSelectOption[] = legalBasisLevels.map(item => ({
      ...item,
      label: item.name,
      value: item.name,
    }));

    setLegalBasisLevelsSelectOptions([
      {
        id: -1,
        name: 'Все уровни',
        label: 'Все уровни',
        value: 'Все уровни',
      },
      ...options,
    ]);
  }, [legalBasisLevels]);

  return {
    refresh,
    legalBasisLevels,
    legalBasisLevelsSelectOptions,
  };
}
